<ion-item *ngIf="Consents?.length" class="full consents" lines="full" fill="outline">
    <ion-label position="stacked" i18n=":@@consumer_request_form.consents">Consentimentos</ion-label>

    <div class="consents-list full">
        <ng-container *ngFor="let group of Consents">
            <p class="consents-group" *ngIf="group?.ConsentTypeList?.length">
                {{ group?.Module?.Name }}<ng-container *ngIf="group?.Project?.Name"> · {{ group.Project.Name
                    }}</ng-container>
            </p>

            <div class="consent-row" *ngFor="let consent of group?.ConsentTypeList">
                <ion-checkbox [checked]="true" [disabled]="true" labelPlacement="end" justify="start">
                    <a *ngIf="consent?.File?.Path; else consentName" [href]="consent.File.Path" target="_blank"
                        rel="noopener" (click)="$event.stopPropagation()">{{ consent?.Type?.Name }}</a>
                    <ng-template #consentName>{{ consent?.Type?.Name }}</ng-template>
                </ion-checkbox>
            </div>
        </ng-container>
    </div>
</ion-item>
